import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo_white.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-68006305")

_pushScopeId("data-v-68006305")
const _hoisted_1 = { class: "mobile-menu-content" }
const _hoisted_2 = { class: "display-flex flex-direction-column align-items-stretch" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  style: {"max-width":"100px"},
  src: _imports_0
}, null, -1)
const _hoisted_4 = { class: "menu" }
const _hoisted_5 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_menu_tile = _resolveComponent("menu-tile")
  const _component_f7_icon = _resolveComponent("f7-icon")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_page = _resolveComponent("f7-page")
  const _component_f7_view = _resolveComponent("f7-view")
  const _component_f7_panel = _resolveComponent("f7-panel")
  const _component_f7_popover = _resolveComponent("f7-popover")
  const _component_login_screen = _resolveComponent("login-screen")
  const _component_f7_app = _resolveComponent("f7-app")

  return (_openBlock(), _createBlock(_component_f7_app, _mergeProps($setup.f7params, { "theme-dark": "" }), {
    default: _withId(() => [
      _createVNode(_component_f7_panel, {
        left: "",
        resizable: ""
      }, {
        default: _withId(() => [
          _createVNode(_component_f7_view, null, {
            default: _withId(() => [
              _createVNode(_component_f7_page, null, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _createVNode("div", _hoisted_2, [
                      _createVNode(_component_f7_link, {
                        "panel-close": "",
                        "reload-all": "",
                        href: $options.appState.admin ? '/' : null,
                        view: ".view-main"
                      }, {
                        default: _withId(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }, 8, ["href"]),
                      _createVNode(_component_menu_tile, {
                        href: "/jobs",
                        class: "panel-close",
                        icon: "pencil_ellipsis_rectangle",
                        title: "Jobs",
                        selected: $setup.currentPageName.includes('job')
                      }, null, 8, ["selected"]),
                      ($options.appState.admin)
                        ? (_openBlock(), _createBlock(_component_menu_tile, {
                            key: 0,
                            href: "/builders",
                            class: "panel-close",
                            icon: "doc_person",
                            title: "Builders",
                            selected: $setup.currentPageName.includes('builder')
                          }, null, 8, ["selected"]))
                        : _createCommentVNode("", true),
                      ($options.appState.admin || ($options.appState.builderData?.roles?.canViewWarehouse ?? false))
                        ? (_openBlock(), _createBlock(_component_menu_tile, {
                            key: 1,
                            class: "panel-close",
                            icon: "bag",
                            title: "Warehouse",
                            selected: $setup.currentPageName === 'store',
                            href: "/store",
                            "data-animate": "false",
                            "data-reload-current": "true"
                          }, null, 8, ["selected"]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_f7_list, {
                      "no-hairlines": "",
                      class: "no-margin"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_f7_list_item, {
                          "popover-close": "",
                          title: $options.appState.email,
                          icon: ""
                        }, {
                          media: _withId(() => [
                            _createVNode(_component_f7_icon, { f7: "person_crop_circle" })
                          ]),
                          _: 1
                        }, 8, ["title"]),
                        _createVNode(_component_f7_list_item, {
                          link: "#",
                          onClick: $options.logout,
                          "popover-close": "",
                          title: "Logout"
                        }, {
                          media: _withId(() => [
                            _createVNode(_component_f7_icon, { f7: "arrow_left_square" })
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", null, [
          _createVNode(_component_f7_link, {
            "reload-all": "",
            href: $options.appState.admin ? '/' : null,
            view: ".view-main"
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["href"]),
          _createVNode(_component_menu_tile, {
            href: "/jobs",
            class: "panel-close",
            icon: "pencil_ellipsis_rectangle",
            title: "Jobs",
            selected: $setup.currentPageName.includes('job')
          }, null, 8, ["selected"]),
          ($options.appState.admin)
            ? (_openBlock(), _createBlock(_component_menu_tile, {
                key: 0,
                href: "/builders",
                class: "panel-close",
                icon: "doc_person",
                title: "Builders",
                selected: $setup.currentPageName.includes('builder')
              }, null, 8, ["selected"]))
            : _createCommentVNode("", true),
          ($options.appState.admin || ($options.appState.builderData?.roles?.canViewWarehouse ?? false))
            ? (_openBlock(), _createBlock(_component_menu_tile, {
                key: 1,
                class: "panel-close",
                icon: "bag",
                title: "Warehouse",
                selected: $setup.currentPageName === 'store',
                href: "/store",
                "data-animate": "false",
                "data-reload-current": "true"
              }, null, 8, ["selected"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_f7_link, {
          style: {"padding":"2rem"},
          link: "#",
          "popover-open": "#user-menu",
          "icon-f7": "person_crop_circle",
          "icon-size": "32"
        }),
        _createVNode(_component_f7_popover, { id: "user-menu" }, {
          default: _withId(() => [
            _createVNode(_component_f7_list, null, {
              default: _withId(() => [
                _createVNode(_component_f7_list_item, {
                  "popover-close": "",
                  title: $options.appState.email,
                  icon: ""
                }, {
                  media: _withId(() => [
                    _createVNode(_component_f7_icon, { f7: "person_crop_circle" })
                  ]),
                  _: 1
                }, 8, ["title"]),
                _createVNode(_component_f7_list_item, {
                  link: "#",
                  onClick: $options.logout,
                  "popover-close": "",
                  title: "Logout"
                }, {
                  media: _withId(() => [
                    _createVNode(_component_f7_icon, { f7: "arrow_left_square" })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_f7_view, {
        main: "",
        class: "safe-areas",
        "dom-cache": false
      }, {
        default: _withId(() => [
          _createVNode("div", {
            class: `${
          $setup.detailPreviewHidden && 'display-none'
        } page-detail-placeholder`
          }, " Make a selection on the left ", 2)
        ]),
        _: 1
      }),
      _createVNode(_component_login_screen)
    ]),
    _: 1
  }, 16))
})